module.exports = __webpack_public_path__ + "img/Employees_grey.004f1514.svg";